import React, { useEffect, useReducer, useCallback, useContext, useState } from "react";
import {
  dataFetchReducer,
  useStateConnectedToCache,
} from "../../Utils/requestUtils";
import Filter from "./Filter/Filter";
import Pagination from "@material-ui/lab/Pagination";
import { CircularProgress } from "@material-ui/core";
import axios from "axios";
import BillPaymentCard from "./BillPaymentCard/BillPaymentCard";
import ErrorBoundary from "../../Utils/ErrorBoundary";
import AuthContext from "../../../context/auth-context";
import { useHistory } from "react-router-dom";
import CardListHeader from "./CardListHeader/CardListHeader";
import FraudReportDialog from "./FraudReportDialog/FraudReportDialog"
import {setTransactionsInSessionStorage} from "../../Utils/utils"

function BillPaymentInbox(props) {
    sessionStorage.removeItem("bill_paymentsArray") 
    let history = useHistory();

    let roles = useContext(AuthContext).user_data.roles;
    if (!roles.includes("read_bill_payments")) {
        history.push("");
    }

    let local_storage_object_preffix = "bill_payment";

    const [pageParams, setPageParams] = useStateConnectedToCache(
        local_storage_object_preffix
    );

    const [pageState, dispatchPageState] = useReducer(dataFetchReducer, {
        fetchedData: null,
        isLoading: true,
        isError: false,
    });

    const doRequest = useCallback(
        (payload) => {
            dispatchPageState({type: "data_fetch_init"})
            axios.get("/dash/bill_payment/bill_payments", {
                params: payload
            }).then(response=>{
                dispatchPageState({
                    type: "data_fetch_success",
                    payload: response.data
                })          
            }).catch(error => {
                if ((error.response || {}).status === 403) dispatchPageState({type: "data_fetch_failure_403"})
                else if ((error.response || {}).status === 404) dispatchPageState({type: "data_fetch_failure_404"})  
                else dispatchPageState({type: "data_fetch_failure"})    
            })
        },[]
    )

    useEffect(() => {
        let payload = {
            "page_number": pageParams.page - 1,
            "page_rows": 25
        }
        Object.keys(pageParams.filters).forEach((key,index) => {
            payload[key] = pageParams.filters[key]
        })
        const timer_ = setTimeout(() => {
            doRequest(payload)
        }, 300);
        return () => {
            clearTimeout(timer_)
		}	
    },[doRequest,pageParams])

    const handleChangePage = (event, page, filters) => {
		if (pageState.page === page) {
			return
		}
		setPageParams({page: page, filters: filters})
	}

    const contentContainer = (dataList) => {

		let nr_of_cards = dataList['data'].length
		let cards = dataList['data'].map((bill_payment) => (
			<ErrorBoundary key={bill_payment.bill_payment_key}>
				<BillPaymentCard bill_payment={bill_payment} />
			</ErrorBoundary>
		))

		if (nr_of_cards === 0) {
			return (
			<div className='emptyContainer'>
				<p className={["blueText", "subtitleSize"].join(" ")}>
					Nada a ser analisado
				</p>
			</div>
			)
		}

		else {
            return (
                <div className='cardContainer'>
                    <CardListHeader />
                    {cards}
                </div>
            )
		}
	}

    const [openFraudReportDialog, setOpenFraudReportDialog] = useState(false)

    if (pageState.fetchedData) {

        setTransactionsInSessionStorage(pageState.fetchedData['data'], local_storage_object_preffix)
        
		return (
			<div style={{ width: "auto", paddingBottom: "30px" }}>
				<div style={{display:"flex"}}>
					<div >
						<p className={["blueText", "titleSize"].join(" ")}>PAGAMENTO DE CONTAS</p>
					</div>
                    <div style={{margin: "auto 20px auto auto"}}>
                    {roles.includes('update_bill_payments') &&
                        <div
                            style={{ padding: "5px 30px", "margin":"5px" }}
                            className={["button", "reproved", "normalText", "normalMediumSize"].join(" ")}
                            onClick={() => setOpenFraudReportDialog(true)}                        
                        >
                            Exportar Relatório de Fraude
                        </div>
                        }
				    </div>
				</div>			
				<ErrorBoundary doNothing><Filter local_storage_object_preffix={local_storage_object_preffix} setPageParams={setPageParams} /></ErrorBoundary>
				<div>{contentContainer(pageState.fetchedData)}</div>
				<div>
                    <Pagination 
                        className="pagination" 
                        page={pageParams.page} 
                        count={parseInt(pageState.fetchedData["number_of_pages"])}
                        onChange={(e, page) => handleChangePage(e, page, pageParams.filters)}
                    />
				</div>
                <FraudReportDialog
                    open={openFraudReportDialog}
                    onClose={() => setOpenFraudReportDialog(false)}
                />
			</div>
		);
	}
	else if (pageState.isError){
		return (
			<div style={{ width: "auto" }}>
				<div style={{display:"flex"}}>
					<div >
						<p className={["blueText", "titleSize"].join(" ")}>PAGAMENTO DE CONTAS</p>
					</div>		
				</div>			
				<ErrorBoundary doNothing><Filter local_storage_object_preffix={local_storage_object_preffix} setPageParams={setPageParams} /></ErrorBoundary>
                <div style={{height: "55vh", display:"flex"}}>
                    <p className={["blueText", "titleSize"].join(" ")} style={{margin:"auto", textAlign:"center"}}>
                        {pageState.errorMessage}
                    </p>
                </div>
			</div>
		)
	}
	else if (pageState.isLoading) {
		return(
			<div style={{ width: "auto" }}>
				<p className={["blueText", "titleSize"].join(" ")}>PAGAMENTO DE CONTAS</p>
				<div className='circularProgressCenter'>
					<CircularProgress />
				</div>
			</div>
		)
    }
    else return null
}

export default BillPaymentInbox;